module.exports = __webpack_public_path__ + "static/media/loading23.17f8ff26.png";


//////////////////
// WEBPACK FOOTER
// ./src/peaceSharkIndex/index/img/loading/loading23.png
// module id = 208
// module chunks = 0